/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AiTutorEvaluationResponseDimension } from './aiTutorEvaluationResponseDimension';

/**
 * Dimension levels without the hidden grading rationale
 */
export type AiTutorEvaluationResponseEvaluation = { [key: string]: AiTutorEvaluationResponseDimension };
